<template>
  <div class="static-page-wrapper" v-html="pageContent"></div>
</template>

<script>
import Utility from "../helpers/utility";

export default {
  name: "HtmlComponent",
  components: {
    //
  },
  props: ["dataResults"],
  data() {
    return {
      pageContent: [],
    };
  },
  mounted() {
    if (
      this.dataResults != "null" &&
      typeof this.dataResults != "undefined" &&
      typeof this.dataResults
    ) {
      this.pageContent =
        JSON.parse(this.dataResults)?.[0]?.page_content ||
        "Something went wrong, pls try again!";
    }
    setTimeout(() => {
      const assetName = Utility.getQueryFromUrl()["assetName"];
      if (assetName === "app") {
        document.getElementById("infoHeader").style.display = "none";
      } else {
        document.getElementById("infoHeader").style.display = "block";
      }
    }, 0);
  },
  methods: {
    //
  },
};
</script>
